import { useLocation } from "react-router-dom";

const usePhoneNumber = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const numberInQuery = query.get("pn");
  const lastCallSaved = window.localStorage.getItem("last_call");
  let phoneNumber = "";

  // If number in query, save it to local storage and return it.
  if (numberInQuery) {
    window.localStorage.setItem("last_call", String(numberInQuery));
    phoneNumber = numberInQuery;
  }

  // If navigating to phone from other part of app, return last saved number.
  if (!numberInQuery && lastCallSaved) {
    phoneNumber = lastCallSaved;
  }

  return phoneNumber;
};

export default usePhoneNumber;
